import { FC } from 'react';

export const NativeAuthSignupPage: FC = () => {
    return <></>;
};
